import axios from "axios";

// Create an Axios instance with a base URL (optional)
const apiClient = axios.create({
  headers: {
  },
});

// Request Interceptor: Add Authorization token to headers
apiClient.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken"); // Retrieve token from localStorage
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`; // Add token to headers
    }
    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error); // Handle request errors
  }
);

// Response Interceptor: Handle errors globally (e.g., 401 Unauthorized)
apiClient.interceptors.response.use(
  (response) => response, // Pass successful responses as-is
  (error) => {
    if (error.response) {
      const { status } = error.response;

      // Handle 401 Unauthorized: Token expired/invalid
      if (status === 401) {
        console.warn("Unauthorized! Redirecting to login...");
        localStorage.removeItem("accessToken"); // Clear the invalid token
        window.location.href = "/login";
      }
    }

    // Log other errors
    console.error("Response error:", error.response || error.message);
    return Promise.reject(error); // Pass the error to the calling function
  }
);

export default apiClient;
